import { render, staticRenderFns } from "./sourcing_trend_market_analysis.vue?vue&type=template&id=720c2564&"
import script from "./sourcing_trend_market_analysis.vue?vue&type=script&lang=js&"
export * from "./sourcing_trend_market_analysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports